import { ModuleType } from "../../queryKeyFactory";

export const paymentKeyFactory = {
  pspConfig: (): [ModuleType, "psp-config"] => ["ix", "psp-config"],
  choices: (choice): [ModuleType, "choice", string] => ["ix", "choice", choice],
  decryptedPspCredentials: (
    pspId: number
  ): [ModuleType, "decrypt-credentials"] => ["ix", "decrypt-credentials"],
};
